import { TsgIntegrationModes, type TsgIntegrationMode } from '@tadpoles/common'

export function isTadpolesMode(mode: TsgIntegrationMode): boolean {
    return mode === TsgIntegrationModes.tadpoles || mode === TsgIntegrationModes.goldAndTadpoles
}
